import { Text, TextTag, createTagOverride } from '@volkswagen-onehub/components-core';
import { MarkdownToJSX } from 'markdown-to-jsx';

interface TagOverrides {
	[index: string]: MarkdownToJSX.Override;
}

/**
 * Fix issues with incorrect display of richtext superscript
 */
const richtextOverridesDefault: TagOverrides = {
	sup: createTagOverride(Text, {
		sup: true,
		tag: TextTag.sup
	})
};

export function getRichtextOverrides(overrides: TagOverrides = {}): TagOverrides {
	return {
		...richtextOverridesDefault,
		...overrides
	};
}
